export const authApi = process.env.REACT_APP_SERVERIP
